"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _actionTypes = require("../constants/action-types");

var _actionTypes2 = _interopRequireDefault(_actionTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var actions = {
  initLion: function initLion(locale, fallbackLocale, appResources, productResources, fallbackAppResources, fallbackProductResources) {
    return {
      type: _actionTypes2.default.INIT_LION,
      payload: {
        locale: locale,
        fallbackLocale: fallbackLocale,
        appResources: appResources,
        productResources: productResources,
        fallbackAppResources: fallbackAppResources,
        fallbackProductResources: fallbackProductResources
      }
    };
  },

  setLionLanguage: function setLionLanguage(locale) {
    return {
      type: _actionTypes2.default.LION_SET_LANGUAGE,
      payload: locale
    };
  },
  setLionFallbackLanguage: function setLionFallbackLanguage(locale) {
    return {
      type: _actionTypes2.default.LION_SET_FALLBACK_LANGUAGE,
      payload: locale
    };
  },

  setLionAppResources: function setLionAppResources(resources, locale) {
    return {
      type: _actionTypes2.default.LION_SET_RESOURCES_APP,
      payload: {
        locale: locale,
        resources: resources
      }
    };
  },
  setLionAppResourcesLoaded: function setLionAppResourcesLoaded(appResourcesLoaded) {
    return {
      type: _actionTypes2.default.LION_SET_RESOURCES_APP_LOADED,
      payload: appResourcesLoaded
    };
  },

  setLionProductResources: function setLionProductResources(resources, locale) {
    return {
      type: _actionTypes2.default.LION_SET_RESOURCES_PRODUCT,
      payload: {
        locale: locale,
        resources: resources
      }
    };
  },
  setLionProductResourcesLoaded: function setLionProductResourcesLoaded(productResourcesLoaded) {
    return {
      type: _actionTypes2.default.LION_SET_RESOURCES_PRODUCT_LOADED,
      payload: productResourcesLoaded
    };
  }
};

exports.default = actions;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@rosetta/react-lion/dist/actions/lion-actions.js
// module id = 881
// module chunks = 0